/**
 * Matches when users request reducing non-essential animations.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */
export const MEDIA_PREFERS_REDUCED_MOTION = '(prefers-reduced-motion: reduce)';